// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".agreement[data-v-0d1fb82c] .bor-b{padding-left:0}.supplementarysForm[data-v-0d1fb82c] .el-dialog__body{height:calc(90vh - 110px);overflow:auto;padding:15px}.supplementarysForm[data-v-0d1fb82c] .el-dialog__footer{text-align:left;padding:0}.supplementarysForm[data-v-0d1fb82c] .el-input-group__append,.supplementarysForm[data-v-0d1fb82c] .el-input-group__prepend{padding:0 10px}", ""]);
// Exports
module.exports = exports;
